import { useNavigate } from "react-router-dom";
import { SystemLogEntry } from "./NotificationModal";
import React from "react";
import { useDispatch } from "react-redux";
import { setActivePageId } from "store/reducers/quotes";
import { getTabById, setActiveTab } from "store/reducers/TabsSlice";
import {
    highlightTicker,
    setActivePage,
} from "store/reducers/QuotesPageReducer";
import { IsUnreadTr } from "./styles";
import { useAppSelector } from "hooks/redux";
import Error from "utils/Notifications/Error";
import { Tooltip } from "antd";

interface SystemLogItemProps {
    log: SystemLogEntry;
    isExpanded: boolean;
    onToggle: () => void;
    formatDateTime: (date: string) => string;
    onRequestClose: (event: React.MouseEvent | React.KeyboardEvent) => void;
    isUnreadSystemLogs: boolean;
}

const SystemLogItem: React.FC<SystemLogItemProps> = ({
    log,
    isExpanded,
    onToggle,
    formatDateTime,
    isUnreadSystemLogs,
    onRequestClose,
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const tabs = useAppSelector((state) => state.tabs);

    const handleLinkClick = async (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!log.ticker_name) return;
        if (log.ticker_name && !log.tab_id) {
            return Error("Для данного тикера отсутствует tab id");
        }

        const tabExists = tabs.tabs.some((tab) => tab.id === log.tab_id);
        if (!tabExists) {
            return Error("123123123Для данного тикера отсутствует tab id");
        }

        dispatch(highlightTicker(null));
        navigate("/quotes");

        try {
            // Устанавливаем ID
            dispatch(setActivePageId(log.tab_id.toString()));
            dispatch(setActiveTab(log.tab_id));

            // Ждём загрузки
            await dispatch(getTabById(log.tab_id));
            dispatch(setActivePage(log.tab_id));

            dispatch(highlightTicker(log.ticker_name));
            onRequestClose(e);
        } catch (error) {
            console.error("Ошибка при загрузке вкладки:", error);
        }
    };

    const hasValidLink =
        log.ticker_name &&
        log.tab_id &&
        tabs.tabs.some((tab) => tab.id === log.tab_id);
    const hasTickerOnly = log.ticker_name && !log.tab_id;
    const isUnread = isUnreadSystemLogs;
    return (
        <>
            <IsUnreadTr
                onClick={onToggle}
                style={{ cursor: "auto" }}
                $isUnread={isUnread}
            >
                <td style={{ width: "130px" }}>
                    {formatDateTime(log.created_at)}
                </td>
                <td>
                    <span
                        style={{
                            color:
                                log.level.toLowerCase() === "error"
                                    ? "red"
                                    : log.level.toLowerCase() === "warning"
                                    ? "orange"
                                    : "green",
                            fontWeight: "bold",
                        }}
                    >
                        {log.level}
                    </span>
                </td>
                <td
                    style={{
                        maxWidth: "400px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        lineHeight: "1.4",
                    }}
                >
                    {hasValidLink && (
                        <span
                            onClick={handleLinkClick}
                            style={{
                                color: "blue",
                                textDecoration: "underline",
                                cursor: "pointer",
                            }}
                            title={`Перейти к ${log.ticker_name}`}
                        >
                            {log.text}
                        </span>
                    )}
                    {hasTickerOnly && (
                        <Tooltip
                            title="Вкладка для этого тикера не найдена"
                            placement="topLeft"
                        >
                            <span
                                style={{
                                    color: "orange",
                                    cursor: "not-allowed",
                                }}
                                // onClick={handleLinkClick}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {log.text}
                            </span>
                        </Tooltip>
                    )}
                    {log.tab_id &&
                        !tabs.tabs.some((tab) => tab.id === log.tab_id) && (
                            <Tooltip
                                title="Вкладка не найдена"
                                placement="topLeft"
                            >
                                <span
                                    style={{
                                        color: "gray",
                                        cursor: "not-allowed",
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {log.text}
                                </span>
                            </Tooltip>
                        )}
                    {!log.tab_id && log.text}
                </td>
            </IsUnreadTr>
        </>
    );
};

export default SystemLogItem;
